import "reflect-metadata";
import { Container, decorate, inject, injectable } from "inversify";

import "../version.js";
import { boot } from "../framework/src/boot/boot";
import { defineEngine } from "../framework/src/engine/pixi/bootPixiEngine";
import { defineSystem } from "../framework/src/system/defineSystem";
import { defineSlotGame as defineGame } from "../framework/src/game/defineGame";
import { defineUI } from "../framework/src/ui/defineUI";

import Commander from "./Commander";
import SERVICE_IDENTIFIER from "../framework/src/constants/identifiers";
import IBootConfig from "../framework/src/boot/IBootConfig";
import InfoPages from "./InfoPages";
import SymbolFactory from "./Symbols/SymbolFactory";
import initSettings from "../framework/src/settings/initSettings";
import { defineJokerWinBanner } from "./JokerWinBanner";
import IframeInfopages from "../framework/src/engine/IframeInfoPages";

let container = new Container();

decorate(injectable(), SymbolFactory);
decorate(inject(SERVICE_IDENTIFIER.SystemConfig), SymbolFactory, 0);
decorate(inject(SERVICE_IDENTIFIER.EngineAppLayers), SymbolFactory, 1);

decorate(injectable(), Commander);
decorate(inject(SERVICE_IDENTIFIER.System), Commander, 0);
decorate(inject(SERVICE_IDENTIFIER.Game), Commander, 1);
decorate(inject(SERVICE_IDENTIFIER.Engine), Commander, 2);
container.bind(SERVICE_IDENTIFIER.Commander).to(Commander).inSingletonScope();

const config: IBootConfig = {
	// @ts-ignore
	EngineAppSymbols: SymbolFactory,
	//@ts-ignore
	InfoPages: IframeInfopages,
};

export async function run(gameset) {
	defineSystem(gameset, container);
	defineEngine(container, config);
	defineGame(container);
	try {
		await initSettings(container);
	} catch (error) {
		return
	}	
	defineUI(container);
	defineJokerWinBanner(container);
	boot(container);
}
